'use client';
import styled, { css } from 'styled-components';

export const StyledHeroBadge = styled.div`
  color: ${props => props.theme.colors.get(props.$fontColor)};
`;

export const StraightBadge = styled.div`
  height: 95px;
  width: 95px;
  border-radius: 50%;
  border: 1.5px solid ${props => props.theme.colors.get(props.$fontColor)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const PrimaryText = styled.p`
  ${props => props.theme.typography.bodyBold};
`;
export const SecondaryText = styled.p`
  ${props =>
    props.$bold
      ? css`
          ${props => props.theme.typography.bodyBold};
        `
      : css`
          ${props => props.theme.typography.body};
          font-size: 13px;
          line-height: 13px;
          padding-bottom: 3px;
        `};
`;

export const CurvedBadge = styled.div`
  height: 95px;
  width: 95px;
  position: relative;
`;

export const SvgLayer = styled.svg`
  width: 95px;
  height: 95px;
  overflow: visible;
`;

export const CurvedText = styled.text`
  width: 100%;
  font-size: 13px;
`;

export const CenterContent = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  padding: 45px;
`;

export const StyledHeroBadges = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(5)};
`;
